import { useQueryClient } from "@tanstack/react-query"

import { useAuthenticatedMutation } from "@l2r-front/l2r-auth"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"
import { l2rApiAxiosInstance } from "@l2r-front/l2r-query"

import { ModulesInfo } from "../../constants/modules"

import { invalidateAttachedObject, invalidateDocumentProject, invalidateDocumentsList } from "../cacheUtils"
import { documentQueryKeys } from "../queries/queryKeys"

export function useDocumentModuleCreate(
    elementType,
    elementId,
    config = {},
) {
    const queryClient = useQueryClient()
    const { selectedNetwork } = useNetworksStateContext()

    const axiosFn = (url, values) => {
        const formData = new FormData()
        Object.entries(values).forEach(([key, value]) => {
            if (key === "attached_object_uuid") {
                return formData.append(elementType, value)
            }
            if (Array.isArray(value)) {
                formData.append(`document.${key}`, JSON.stringify(value))
            } else {
                formData.append(`document.${key}`, value)
            }
        })

        const headers = values.document ? { "Content-Type": "multipart/form-data" } : {}

        return l2rApiAxiosInstance.patch(url, formData, {
            headers: headers,
        })
    }

    const baseUrl = ModulesInfo?.[elementType]?.queryUrl
    const url = `${baseUrl}/${elementId}/`
    const queryKey = documentQueryKeys.element(elementId)

    queryKey.push({ network: selectedNetwork?.slug })

    return useAuthenticatedMutation(
        url,
        axiosFn,
        {},
        {
            ...config,
            onSuccess: (data) => {
                queryClient.invalidateQueries({ queryKey: documentQueryKeys.detail(document.uuid) })
                queryClient.invalidateQueries({ queryKey: documentQueryKeys.authors() })

                invalidateDocumentProject(queryClient, selectedNetwork)
                invalidateDocumentsList(queryClient, selectedNetwork)
                invalidateAttachedObject(queryClient, data)

                config.onSuccess?.(data)
            },
        },
    )
}